export const OffersModelsByAdvertiserSelectTranslationKeys = {
  offerModelsOfferStatusIsInactive: 'offer.models-offer-status-is-inactive',
  offerModelsOfferStatusWorkingConditionsAreNotAccepted: 'offer.models-offer-status-working-conditions-are-not-accepted',
  settingsAffiliateModel: 'settings.affiliate-model',
}
